import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';

gsap.registerPlugin(ScrollTrigger);

/**
 * Initialise l'animation d'un SVG inline avec GSAP + ScrollTrigger
 * - trace les lignes (#line-n)
 * - fait apparaître les textes (#texte-n) juste après
 *
 * @param {string} svgSelector - Sélecteur du SVG (ex: ".fullimage__bg")
 */
export function initFullSvg(svgSelector = ".fullimage__bg") {
	const svg = document.querySelector(svgSelector);
	if (!svg) return;

	const fond = svg.querySelector("image");

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: svg,
			start: "top 70%",
			// toggleActions: "play none none reverse",
			once: true,
			// invalidateOnRefresh: true,
		}
	});

	// Récupère toutes les lignes
	const lines = gsap.utils.toArray(`${svgSelector} path[id^="line-"]`);

	// Étape 1 : afficher l'image de fond
	if (fond) {
		tl.to(fond, {
			opacity: 1,
			delay: 0.2,
			duration: 0.75,
			ease: "power1.out"
		});
	}

	lines.forEach(line => {
		const num = line.id.split("-")[1];
		const texte = svg.querySelector(`#texte-${num}`);

		// Calcul dynamique de la longueur du path
		const length = line.getTotalLength();
		line.style.strokeDasharray = length;
		line.style.strokeDashoffset = length;

		// Étape 2 : tracer la ligne
		tl.to(line, {
			strokeDashoffset: 0,
			duration: 0.6,
			ease: "power1.out"
		}, "-=0.2");

		// Étape 3 : afficher le texte correspondant
		if (texte) {
			gsap.set(texte, { opacity: 0 });
			tl.to(texte, {
				opacity: 1,
				duration: 0.5,
				ease: "power1.out"
			}, "-=0.2");
		}
	});
}